<template>
  <!-- PRESENTATION - THE CHATBOT: remove v-if="false" from the following line, and remove the next section -->
  <v-container
    v-if="false"
    fluid

    pa-0
  >
    <!-- DESKTOP AND WIDE SCREENS -->
    <v-layout
            fill-height
      pa-0
      wrap
      row
      class="hidden-sm-and-down"
    >
      <v-flex>
        <multipane
          class="vertical-panes"
          layout="vertical"
        >
          <div
            class="vpane"
            :style="{ minWidth: '50%', maxWidth: '75%' }"
          >
            <v-layout
              row
              wrap
            >
              <router-view />
            </v-layout>
          </div>
          <multipane-resizer>
            <div class="vline" />
          </multipane-resizer>
          <!-- CHATBOT -->
          <div
            class="vpane"
            :style="{ flexGrow: 1 }"
          >
            <Chatbot />
          </div>
        </multipane>
      </v-flex>
    </v-layout>

    <!-- MOBILE AND SMALL SCREENS -->
    <v-layout
      v-if="false"
      pa-0
      wrap
      row
      class="hidden-md-and-up"
    >
      <v-btn
        fixed
        dark
        fab
        bottom
        right
        color="pink"
        @click="mobile.openChatPanel = true"
      >
        <v-icon>message</v-icon>
      </v-btn>
      <v-flex>
        <v-layout
          row
          wrap
          class="ma-2"
        >
          <router-view />
        </v-layout>
      </v-flex>
      <v-dialog
        v-model="mobile.openChatPanel"
        persistent
        fullscreen
        class="dialog"
        transition="dialog-bottom-transition"
      >
        <v-card class="rounded pa-2">
          <v-layout
            row
            wrap
          >
            <v-flex
              xs10
              class="px-2"
            >
              <p class="headline grey--text">
                Chat
              </p>
            </v-flex>
            <v-flex xs2>
              <v-layout justify-end>
                <v-btn
                  icon
                  small
                  @click="mobile.openChatPanel = false"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <Chatbot />
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>

  <v-container
    v-else
    fluid
    fill-height
    pa-0
  >
    <v-layout
      pa-0
      wrap
      row
    >
      <v-flex>
        <router-view />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {Multipane, MultipaneResizer,} from "vue-multipane";
import Chatbot from "@/components/Chatbot/Chatbot";

export default {
    name: "DialogsTraining",
    components: {
        Chatbot,
        Multipane,
        MultipaneResizer,
    },
    data() {
        return {
            mobile: {
                openChatPanel: false,
            },
            intentsHeader: "Intents",
            intents: [
                {
                    id: 1,
                    name: "Welcome",
                    description: "This intent is used to present the assistant to the user.",
                },
                {divider: true, inset: true,},
                {
                    id: 2,
                    name: "Fallback",
                    description: "This intent is fired when the assistant does not understand.",
                },
                {divider: true, inset: true,},
                {
                    id: 3,
                    name: "Thank you",
                    description: "Useful to answer to thank you utterances.",
                },
            ],
        };
    },
};
</script>

<style lang="scss">

</style>

